import apiClient from '@/utils/api';

/**
 * 옴니채널 메시지 발송 (RCS → SMS 폴백)
 * API 키는 서버에서만 보관하며, 백엔드를 통해 발송합니다.
 */
export async function sendOmniMessage({ destinations, rcsText, smsText, ref = '' }) {
  const response = await apiClient.post('/api/message/send', {
    destinations,
    rcsText,
    smsText: smsText || undefined,
    ref,
  });
  return response.data.data;
}

/**
 * 카카오 알림톡 발송 (알림톡 → SMS 폴백)
 *
 * @param {string}   type          템플릿 타입 (예: 'ticket_issued')
 * @param {Object[]} destinations  수신자 배열 { to: string, replaceWords: Object }
 * @param {string}   [ref]
 */
export async function sendAlimtalk({ type, destinations, ref = 'ticket-issued' }) {
  const response = await apiClient.post('/api/message/send/alimtalk', {
    type,
    destinations,
    ref,
  });
  return response.data.data;
}
